import { useState } from "react";
import { useRole } from "../contextApi/RoleContext";
import ContentLoader from "react-content-loader";
import { API } from "../../helper/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Line,
} from "recharts";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { RotatingLines } from "react-loader-spinner";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const { setRole, role, setPermission, permission, setUserDetails,userDetails} =useRole();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateFilter, setDateFilter] = useState("0");
  const [showDatePic, setShowDatePic] = useState(false);
  const [barData, setBarData] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);
  const [salesCount, setSalesCount] = useState(0);
  const [purchaseCount, setPurchaseCount] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [employeeCount, setEmployeeCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasRecord, setHasRecord] = useState(false);
  const [activeBtn, setActiveBtn] = useState("5");
  const [userName, setUserName] = useState(Cookies.get("username"));
  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [formatedDates1, setFormatedDates1] = useState("");
  const [formatedDates2, setFormatedDates2] = useState("");
  const [pieData, setPieData] = useState([]);
  const [controlLoader,setControlLoader]=useState(true);
  //console.log("c", role);
  // const piedata = [
  //   { name: "Sales Orders", value: 4000 + 3000 + 2000 + 2780 },
  //   { name: "Purchases Orders", value: 2400 + 1398 + 9800 + 3908 },
  // ];
  const COLORS = ["#2196f3", "#00C49F"]; // Colors for pie slices

  // const data = [
  //   { name: "Jan", so: 200, po: 200 },
  //   { name: "Feb", so: 400, po: 400 },
  //   { name: "March", so: 600, po: 600 },
  //   { name: "April", so: 800, po: 800 },
  //   { name: "May", so: 1000, po: 1000 },
  //   { name: "June", so: 1200, po: 1200 },
  //   { name: "July", so: 1400, po: 1400 },
  //   { name: "Aug", so: 1600, po: 1600 },
  //   { name: "Sept", so: 1800, po: 1800 },
  //   { name: "Oct", so: 2000, po: 2000 },
  //   { name: "Nov", so: 2200, po: 2200 },
  //   { name: "Dec", so: 2400, po: 2400 },
  // ];
  const page = { page: 0 };

  const formatDate1 = (getDate) => {
    // Get today's date
    const today = new Date(getDate);
    // Format the date
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = today
      .toLocaleDateString("en-US", options)
      .replace(",", "");
    return formattedDate;
  };

  ///fetch product count////
  const catalogLists = async() => {
    try{
await  API.getData(0,2)
.then((datas) => {
 
  // const items = datas.ApiDocument.Response.Styles.flatMap(
  //   (style) => style
  // );
 // console.log("catalog list", items);
  const totalRecords = datas.ApiDocument.TotalRecords;
  setProductCount(totalRecords);
  // setTotalRecords(totalRecords);
 // setPending(false);
})

    }catch(err){
      console.error("Error fetching product data:", err);
    }

   
  };



  ////////end////////////////

  ///fetch product count////
 const employeeList = async() => {
     try{
      await  API.getEmployee({page:0})
      .then((datas) => {
        
        // const items = datas.ApiDocument.Response.Employees.flatMap(
        //   (Employees) => Employees
        // );
        const totalRecords = datas.ApiDocument.TotalRecords;
       setEmployeeCount(totalRecords);
      })
     }catch(err){
      console.error("Error fetching Employee data:", err);
     }
  
   };



  ////////end////////////////

  useEffect(() => {
    setFormatedDates1(formatDate1(new Date()));
    setFormatedDates2(formatDate1(new Date()));

    const fetchData = async () => {
      //console.log("test");
      try {
        // console.log("start");
        await Promise.all([
          API.getSalesRecipt(page).then((data) => {
            let filteredSales;
            let items;

            if(userDetails.usertype !=="CORP"){
              filteredSales = data.ApiDocument.Response.SalesReceipts.filter(rec => userDetails.storecode?.some(itm=> itm.storecode === rec.Location));
              items = filteredSales.flatMap(
               (SalesReport) => SalesReport.RecModified
             );
              setSalesCount(items.length);
            }else{
             
              items = data.ApiDocument.Response.SalesReceipts.flatMap(
               (SalesReport) => SalesReport.RecModified
             );
              setSalesCount(data.ApiDocument.TotalRecords);
            }
            
          //  console.log("first apis", filteredStores);
            setSalesData(items);
            // setSalesCount(data.ApiDocument.TotalRecords);
          }),
          API.getPurchaseOrder(page).then((datas) => {
            let filteredPurchase;
            let items1;
            if(userDetails.usertype !=="CORP"){
              filteredPurchase = datas.ApiDocument.Response.PurchaseOrders.filter(rec => 
                rec.PurchaseReceipts?.some(location => 
                  userDetails.storecode?.some(store => store.storecode === location.LocationIdentifier)
                )
              );
              items1 = filteredPurchase.flatMap(
                (PurchaseOrders) => PurchaseOrders.OrderDate 
              );
              setPurchaseCount(items1.length);
            }else{
              items1 = datas.ApiDocument.Response.PurchaseOrders.flatMap(
                (PurchaseOrders) => PurchaseOrders.OrderDate 
              );
              setPurchaseCount(datas.ApiDocument.TotalRecords);
            }
           
           
            
            setPurchaseData(items1);
             // console.log("second api*", filteredPurchase);
            // setPurchaseCount(datas.ApiDocument.TotalRecords);
          }),
        ]);
        setIsLoading(false);
        // console.log("end");
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchData();
    catalogLists();
    employeeList();
    console.log("permissions",userDetails.storecode)
  }, []);



  useEffect(() => {
    filterData("5");
    
    // console.log("final data check", salesData);
    // if (salesCount > 0 && purchaseCount > 0) {
    //   setPieData([
    //     { name: "Sales Orders", value: salesCount },
    //     { name: "Purchase Orders", value: purchaseCount },
    //   ]);
    //   setHasRecord(false);
    //   filterData("0");
    // } else {
    //   setHasRecord(true);
    // }
  }, [isLoading]);

  //functions for date calculations
  const getStartOfToday = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  };

  const getLast24Hours = () => {
    const now = new Date();
    return new Date(now.getTime() - 24 * 60 * 60 * 1000);
  };

  const getLast7Days = () => {
    const now = new Date();
    return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  };

  const getStartOfMonth = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1);
  };

  const getStartOfYear = () => {
    const today = new Date();
    return new Date(today.getFullYear(), 0, 1);
  };

  const getStartOfTwoYearsAgo = () => {
    const today = new Date();
    return new Date(today.getFullYear() - 2, 0, 1);
  };

  // Filter function
  const filterData = (filterType) => {
    let startDate = null;
    let endDate = new Date(); // Current date and time
    if (filterType !== "none") {
      switch (filterType) {
        case "0":
          startDate = getStartOfToday();
          break;
        case "1":
          startDate = getLast24Hours();
          break;
        case "2":
          startDate = getLast7Days();
          break;
        case "3":
          startDate = getStartOfMonth();
          break;
        case "4":
          startDate = getStartOfYear();
          break;
        case "5":
          startDate = getStartOfTwoYearsAgo();
          break;
        default:
          throw new Error("Invalid filter type");
      }
    } else {
      startDate = new Date(fromDate);
      endDate = new Date(toDate);
    }
    // console.log("start date", startDate);
    // console.log("end date", endDate);
    const filteredSalesRec = salesData.filter((item) => {
      const itemDate = new Date(item);
      const startDate1 = new Date(startDate);
      const endDate1 = new Date(endDate);
  
      startDate1.setHours(0, 0, 0, 0); // Set to start of the day (00:00:00)
      endDate1.setHours(23, 59, 59, 999); // Set to end of the day (23:59:59.999)
      return itemDate >= startDate1 && itemDate <= endDate1;
    });
    const filteredPurchaseRec = purchaseData.filter((item) => {
      const itemDate1 = new Date(item);
      const startDate1 = new Date(startDate);
      const endDate1 = new Date(endDate);
  
      startDate1.setHours(0, 0, 0, 0); // Set to start of the day (00:00:00)
      endDate1.setHours(23, 59, 59, 999); // Set to end of the day (23:59:59.999)
      return itemDate1 >= startDate1 && itemDate1 <= endDate1;
    });
    const transformedData = transformData(
      filteredSalesRec,
      filteredPurchaseRec
    );
    console.log("sales", filteredSalesRec);
    console.log("purchase", filteredPurchaseRec);
    setBarData(transformedData);
    setSalesCount(filteredSalesRec.length);
    setPurchaseCount(filteredPurchaseRec.length);
    // setSalesCount(filteredSalesRec.length);
    // setPurchaseCount(filteredPurchaseRec.length);
    // if (filteredSalesRec.length > 0 || filteredPurchaseRec.length > 0) {
    //   setPieData([
    //     { name: "Sales Orders", value: filteredSalesRec.length },
    //     { name: "Purchases Orders", value: filteredPurchaseRec.length },
    //   ]);
    //   setHasRecord(false);
    // } else {
    //   setHasRecord(true);
    // }
    setPieData([
      { name: "Sales", value: filteredSalesRec.length },
      { name: "Purchase Orders", value: filteredPurchaseRec.length },
    ]);
    if(barData.length > 0){
      setControlLoader(false)
    }

   // setControlLoader(false);
    //setHasRecord(true);
    // console.log("checkpie", pieData.length);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const validation = (message) => {
    toast.error(message, {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      className: "login-toast",
    });
  };

  const handleApply = () => {
    const from = new Date(fromDate);
    const to = new Date(toDate);

    var track = false;
    if (!fromDate || !toDate) {
      validation("Both From Date and To Date are required.");
      track = true;
    }
    if (from > to) {
      validation("From Date shouldn't be after To Date.");
      track = true;
    }
    // if (from.getTime() === to.getTime()) {
    //   validation("From Date and To Date shouldn't be the same.");
    //   track = true;
    // }
    if (!track) {
      setFormatedDates1(formatDate1(from));
      setFormatedDates2(formatDate1(to));
      setShowDatePickerModal(false);
      filterData("none");
    } else {
      filterData("0");
    }

    // console.log("From Date: ", fromDate);
    // console.log("To Date: ", toDate);
  };
  ///show data picker popup
  const showModal = () => {
    //alert("test");
    filterData("0");
    setActiveBtn("6");
    setShowDatePickerModal(true);
  };
  /////end///////
  const handleFilter = (get) => {
    setControlLoader(false);
    setFromDate("");
    setToDate("");
    var getVal = get;
    setDateFilter(getVal);
    // if (getVal === "6") {
    //   setShowDatePic(true);
    // } else {
    // console.log("testactive", get);
    setActiveBtn(get);
    setShowDatePic(false);
    filterData(getVal);
    setFormatedDates1(formatDate1(new Date()));
    setFormatedDates2(formatDate1(new Date()));
    // }

    // console.log("bargraphdata", transformedData);
  };

  ///bargraph data manupulation
  const transformData = (res1, res2) => {
    const monthNames = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Helper to aggregate counts by month
    const aggregateCounts = (data) => {
      return data.reduce((acc, dateString) => {
        const date = new Date(dateString);
        const month = monthNames[date.getMonth()]; // Extract month name
        acc[month] = (acc[month] || 0) + 1; // Increment count for the month
        return acc;
      }, {});
    };

    // Aggregate counts for res1 and res2
    const res1Counts = aggregateCounts(res1);
    const res2Counts = aggregateCounts(res2);

    // Combine both counts into a single dataset
    const allMonths = new Set([
      ...Object.keys(res1Counts),
      ...Object.keys(res2Counts),
    ]);
    // Convert the Set to an array, sort it according to the predefined order
    const sortedMonths = Array.from(allMonths).sort(
      (a, b) => monthNames.indexOf(a) - monthNames.indexOf(b)
    );
    //console.log("*", sortedMonths);
    return Array.from(sortedMonths).map((month) => ({
      name: month,
      so: res1Counts[month] || 0,
      po: res2Counts[month] || 0,
    }));
  };

  ///end/////

  return (
    <>
     
      <div class="container-fluid page-body-wrapper">
        <div class="main-panel">
          <div class="content-wrapper">
            {console.log("check loader status",isLoading)}
            {isLoading ? <div className="loader-overlays">
            <RotatingLines
                      visible={true}
                      height="96"
                      width="96"
                      strokeColor="white"
                      strokeWidth="2"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    /></div> : null}   
            
            <div style={{ marginTop: "-20px" }}>
              <ToastContainer
                position="top-center"
                autoClose={500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
              <div class="row">
                <div className="col-md-5 mt-2">
                  {userName ? (
                    <>
                      <h2 style={{ fontSize: "20px" }}>
                        Welcome back, <span className="Gradient">{userName} !</span>
                      </h2>
                      <p>Track your sales activity, leads and deals here.</p>
                    </>
                  ) : null}
                </div>
                <div className="col-md-4 mt-2">
                  <div className="dashboardheader">
                    <button
                      className={`dashboardbtn ${
                        activeBtn === "0" ? "active" : ""
                      }`}
                      onClick={() => handleFilter("0")}
                    >
                      Today
                    </button>
                    <span>|</span>
                    <button
                      className={`dashboardbtn ${
                        activeBtn === "2" ? "active" : ""
                      }`}
                      onClick={() => handleFilter("2")}
                    >
                      7 Days
                    </button>
                    <span>|</span>
                    <button
                      className={`dashboardbtn ${
                        activeBtn === "3" ? "active" : ""
                      }`}
                      onClick={() => handleFilter("3")}
                    >
                      1 Month
                    </button>
                    <span>|</span>
                    <button
                      className={`dashboardbtn ${
                        activeBtn === "4" ? "active" : ""
                      }`}
                      onClick={() => handleFilter("4")}
                    >
                      YTD
                    </button>
                    <span>|</span>
                    <button
                      className={`dashboardbtn ${
                        activeBtn === "5" ? "active" : ""
                      }`}
                      onClick={() => handleFilter("5")}
                    >
                      2YTD
                    </button>
                  </div>

                  {/* <select
                    id="status1"
                    className="customdropdown"
                    // style={{
                    //   marginTop: "31px",
                    //   height: "44px",
                    //   fontWeight: "600",
                    // }}
                    value={dateFilter}
                    onChange={handleFilter}
                  >
                    <option value="0">Today</option>
                    <option value="1">Last 24 Hours</option>
                    <option value="2">Last 7 Days</option>
                    <option value="3">Current Month</option>
                    <option value="4">YTD</option>
                    <option value="5">2YTD</option>
                    <option value="6">Custom</option>
                  </select> */}
                </div>
                <div className="col-md-3 mt-2">
                  <div
                    className={`dashboardheader2 ${
                      activeBtn === "6" ? "active" : ""
                    }`}
                    onClick={showModal}
                  >
                    <i class="mdi mdi-calendar"></i>
                    {formatedDates1} - <i class="mdi mdi-calendar"></i>
                    {formatedDates2}
                    <span style={{ fontSize: "14px", marginLeft: "-5px" }}>
                      ▾
                    </span>
                  </div>
                </div>

                {/* {showDatePic ? (
                  
                ) : null} */}
              </div>
            </div>

            <div class="row ">
              <div class="col-md-6 mt-4 mb-4">
                <div class="piechartbody">
                  {barData.length > 0 ? (
                    <BarChart
                      width={500}
                      height={300}
                      data={barData}
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar name="Sales" dataKey="so" fill="#2196f3" />
                      <Bar name="Purchase Orders" dataKey="po" fill="#00C49F" />
                    </BarChart>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "300px",
                      }}
                    >
                    {controlLoader ? (
                      <div className="loader">
                    {/* <RotatingLines
                      visible={true}
                      height="96"
                      width="96"
                      strokeColor="grey"
                      strokeWidth="2"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    /> */}
                  </div>
                    ):( <p style={{ fontSize: "16px" }}>No record available</p>)}
                     
                    </div>
                  )}
                </div>
              </div>
              <div class="col-md-6 mt-4 mb-4">
                <div class="piechartbody">
                  {/* {isLoading ? (
                    <ContentLoader
                      speed={2}
                      width={476}
                      height={300}
                      // viewBox="0 0 476 204"
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb"
                    >
                      <circle cx="294" cy="130" r="90" />
                      <rect
                        x="168"
                        y="250"
                        rx="0"
                        ry="0"
                        width="20"
                        height="13"
                      />
                      <rect
                        x="285"
                        y="250"
                        rx="0"
                        ry="0"
                        width="20"
                        height="13"
                      />
                    </ContentLoader>
                  ) : hasRecord ? ( */}

                  {/* ) : ( */}
                  {barData.length > 0 ? (
                    <PieChart width={500} height={300}>
                      <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="value"
                        label
                      >
                        {pieData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "300px",
                      }}
                    >
                     {controlLoader ? (
                      <div className="loader">
                    {/* <RotatingLines
                      visible={true}
                      height="96"
                      width="96"
                      strokeColor="grey"
                      strokeWidth="2"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    /> */}
                  </div>
                    ):( <p style={{ fontSize: "16px" }}>No record available</p>)}
                    </div>
                  )}

                  {/* )} */}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="tab-content tab-transparent-content">
                  <div
                    class="tab-pane fade show active"
                    id="business-1"
                    role="tabpanel"
                    aria-labelledby="business-tab"
                  >
                    <div class="row">
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card customCard" >
                          <div class="card-body text-center">
                            <h5 class="mb-2 text-dark font-weight-normal">
                            #Tickets
                            </h5>
                            <h2 class="mb-4 text-dark font-weight-bold">{salesCount}</h2>
                             <div class="dashboard-progress dashboard-progress-4 d-flex align-items-center justify-content-center item-parent">
                              <i class="mdi mdi-cube icon-md absolute-center text-dark" style={{marginTop:"10px"}}></i>
                            </div>
                            <p class="mt-4 mb-0"><Link to='tickets-history'>Details..</Link></p>
                            <h3 class="mb-0 font-weight-bold mt-2 text-dark">
                            
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card customCard">
                          <div class="card-body text-center">
                            <h5 class="mb-2 text-dark font-weight-normal">
                               Purchase Orders
                            </h5>
                            <h2 class="mb-4 text-dark font-weight-bold">{purchaseCount}</h2>
                            <div class="dashboard-progress dashboard-progress-2 d-flex align-items-center justify-content-center item-parent">
                            <i class="mdi mdi-eye icon-md absolute-center text-dark" style={{marginTop:"10px"}}></i>
                              
                            </div>
                            <p class="mt-4 mb-0"><Link to='#'>Details..</Link></p>
                            <h3 class="mb-0 font-weight-bold mt-2 text-dark">
                            
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3  col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card customCard">
                          <div class="card-body text-center">
                            <h5 class="mb-2 text-dark font-weight-normal">
                            Products
                            </h5>
                            <h2 class="mb-4 text-dark font-weight-bold">
                              {productCount}
                            </h2>
                            <div class="dashboard-progress dashboard-progress-3 d-flex align-items-center justify-content-center item-parent">
                            <i class="mdi mdi-lightbulb icon-md absolute-center text-dark" style={{marginTop:"10px"}}></i>
                            </div>
                            <p class="mt-4 mb-0"><Link to='#'>Details..</Link></p>
                            <h3 class="mb-0 font-weight-bold mt-2 text-dark">
                             
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card customCard">
                          <div class="card-body text-center">
                            <h5 class="mb-2 text-dark font-weight-normal">
                              Employee
                            </h5>
                            <h2 class="mb-4 text-dark font-weight-bold">
                              {employeeCount}
                            </h2>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent">
                              <i class="mdi mdi-account-circle icon-md absolute-center text-dark" style={{marginTop:"10px"}}></i>
                            </div>
                          
                            <p class="mt-4 mb-0"><Link to='#'>Details..</Link></p>
                            <h3 class="mb-0 font-weight-bold mt-2 text-dark">
                              
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {/* Modal for password reset */}
        {showDatePickerModal ? (
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              padding: "20px",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => setShowDatePickerModal(false)}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "2rem",
                borderRadius: "8px",
                width: "500px",
                marginTop: "40px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
              onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
            >
              <div className="row">
                <>
                  <div className="col-md-5">
                    <label htmlFor="fromDate" className="form-label">
                      From Date
                    </label>
                    <input
                      type="date"
                      id="fromDate"
                      className="form-control"
                      // style={{ width: "50%" }}
                      value={fromDate}
                      onChange={handleFromDateChange}
                    />
                  </div>
                  <div className="col-md-5">
                    <label htmlFor="toDate" className="form-label">
                      To Date
                    </label>
                    <input
                      type="date"
                      id="toDate"
                      // style={{ width: "50%" }}
                      className="form-control"
                      value={toDate}
                      onChange={handleToDateChange}
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-primary w-72"
                      style={{ marginTop: "32px" }}
                      onClick={handleApply}
                    >
                      Apply
                    </button>
                  </div>
                </>{" "}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}